// services/user/UserGalleryService.js
import API from "../../api/apiUser";

const UserGalleryService = {
    async getGalleryItems() {
        const res = await API.get("/user/gallery");
        return res.data; // Return the whole response as the page handles .data or array
    },
    async getGallery() {
        const res = await API.get("/user/gallery");
        return res.data.data;
    },
};

export default UserGalleryService;
